import { animated, useSpring } from '@react-spring/web';
import React, { FC, PropsWithChildren, useEffect } from 'react';
import { useMeasure } from 'react-use';
import { useCollapsible } from '../collapsible-context';

export type CollapsibleContentProps = PropsWithChildren<{
  /**
   * Represents the class name of an element.
   */
  className?: string;
}>;

export const CollapsibleContent: FC<CollapsibleContentProps> = ({
  children,
  className,
}) => {
  const [contentRef, { height }] = useMeasure<HTMLDivElement>();

  const [style, animate] = useSpring(() => ({ height: '0px', opacity: 0 }), []);
  const { open } = useCollapsible();

  useEffect(() => {
    animate({
      opacity: open ? 1 : 0,
      height: (open ? height ?? 0 : 0) + 'px',
      config: {
        duration: 200,
      },
    });
  }, [animate, contentRef, open, height]);

  return (
    <animated.div style={style}>
      <div ref={contentRef} className={className}>{children}</div>
    </animated.div>
  );
};
